export default "__VITE_ASSET__CIYMWJus__"